import { isProductionFunction } from "../utils/MiscUtil";

export const SweamersConfig = {
  STRIPE_PUBLISHABLE_KEY: isProductionFunction()
    ? "pk_live_51MIR6lI0DuCvYjvx7eM9z13SVa7gb498muawJDOXdp05YXuskeDdsgzeok3KciDBsMASWAkF45IxYTNqMHRj2ioS00EdbSxMv7"
    : "pk_test_51MIR6lI0DuCvYjvxXF5B84hdxaclErL6MAYaa7KFVV0Gn3D5BdzULAnaMcvRctkisALndgOaJu8a1d8h3zXqhkof00SryeHXtQ",
};
